import React from 'react';
import { X } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import './Modal.css';

const PrivateModal = ({ onClose }) => {
  const { t } = useLanguage();

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} aria-label={t('common.close')}>
          <X size={24} />
        </button>

        <div className="modal-header">
          <h2>{t('priv.title')}</h2>
        </div>

        <div className="modal-body">
          <div className="modal-image">
            <img
              src="https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800"
              alt=""
            />
          </div>

          <div className="modal-text">
            <h3>{t('priv.h3')}</h3>
            <p>{t('priv.p1')}</p>

            <h4>{t('priv.h4')}</h4>
            <ul>
              {t('priv.list').map((item, i) => <li key={i}>{item}</li>)}
            </ul>

            <p>{t('priv.p2')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivateModal;
